import React from "react";
import { Link } from "react-router-dom";
import BrandLogo from "./BrandLogo";
import { MINISTRY_NAME, MINISTRY_SITE_URL, SOCIAL_LINKS, ZANIFY_URL } from "../config";

// <Footer />        the full footer of the public pages
// <Footer slim />   a single line, used under the dashboard
function Footer({ slim = false }) {
    const currentYear = new Date().getFullYear();

    if (slim) {
        return (
            <footer className="cf-footer is-slim">
                <div className="cf-wrap cf-footer-bottom">
                    <span>&copy; {currentYear} {MINISTRY_NAME}. All rights reserved.</span>
                    <span className="cf-footer-links">
                        <Link to="/privacy-policy">Privacy Policy</Link>
                        <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>
                        <a href={ZANIFY_URL} target="_blank" rel="noopener noreferrer">Developed by Zanify Technologies</a>
                    </span>
                </div>
            </footer>
        );
    }

    return (
        <footer className="cf-footer">
            <div className="cf-wrap">
                <div className="cf-footer-top">
                    <div>
                        <Link to="/" aria-label="CFCM Portal home"><BrandLogo light size={34} /></Link>
                        <p>
                            The members' portal of {MINISTRY_NAME}: school missions, events, the Peniel
                            Prayer and Retreat Center in Makuyu, and giving.
                        </p>
                    </div>
                    <nav className="cf-footer-col" aria-label="The ministry">
                        <h4>The ministry</h4>
                        <Link to="/about-us">About us</Link>
                        <Link to="/events">Events</Link>
                        <Link to="/makuyu-prayer-center-booking">Prayer center booking</Link>
                        <Link to="/support-the-ministry">Support the ministry</Link>
                        <a href={MINISTRY_SITE_URL} target="_blank" rel="noopener noreferrer">cfcm.co.ke</a>
                    </nav>
                    <nav className="cf-footer-col" aria-label="Account">
                        <h4>Account</h4>
                        <Link to="/signup">Become a member</Link>
                        <Link to="/login">Sign in</Link>
                        <Link to="/account/forgot-password">Forgot password</Link>
                    </nav>
                    <nav className="cf-footer-col" aria-label="Follow us">
                        <h4>Follow us</h4>
                        {SOCIAL_LINKS.map((link) => (
                            <a href={link.url} key={link.name} target="_blank" rel="noopener noreferrer">{link.name}</a>
                        ))}
                        <Link to="/privacy-policy">Privacy Policy</Link>
                        <Link to="/terms-and-conditions">Terms &amp; Conditions</Link>
                    </nav>
                </div>
                <div className="cf-footer-bottom">
                    <span>&copy; {currentYear} {MINISTRY_NAME}. All rights reserved.</span>
                    <span>Developed by <a href={ZANIFY_URL} target="_blank" rel="noopener noreferrer">Zanify Technologies</a></span>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
